<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 border-bottom">
    <h1 class="h2">Features</h1>
</div>


<div *ngIf="!loading" class="row scrollContainer col-md-10" style="margin-bottom: 20px;">
    <div class="col-md-9 mb-9 scrollColumn tab">
        <app-table [dataSource]="dataSource" [displayedColumns]="displayedColumns" *ngIf="!loading" uniqueKey="features"
            (rowClick)="onRowClick($event)"></app-table>
    </div>
    <div class="col-md-3">
        <app-activity [tab]="true" [id]="0" table="feature" />
    </div>
</div>

<ng-template #updateDialog>
    <h2 matDialogTitle>{{selectedFeature.name}}</h2>
    @if (!childLoading) {
        <mat-dialog-content>
            @if (selectedFeature.removed) {
                <p class="text-muted">
                    <strong>⚠️ Removed:</strong>
                    This feature does nothing in the <strong>current</strong> version of weavix.
                    Changes to this setting will only affect users on previous versions, in order to ensure backward compatibility.
                </p>
            }
            <p><strong>Description:</strong> {{selectedFeature.description}}</p>
            <div>
                <mat-checkbox color="primary" name="enabled" [(ngModel)]="enabledCheckboxValue">
                    Enable By Default
                </mat-checkbox>
            </div>
            <hr>
            <h2>Usage</h2>
            <div>
                @for (use of featureUsage | keyvalue; track use.key) {
                    <strong>{{use.value.accountName}}</strong>
                    @if (use.value.accountSetting !== undefined) {
                        <p>Account Setting: {{use.value.accountSetting}}</p>
                    } @else {
                        <p>Enabled Sites: {{ this.siteEnablement[use.key].enabled }}</p>
                        <p>Disabled Sites: {{ this.siteEnablement[use.key].disabled }}</p>
                    }
                }
            </div>

        </mat-dialog-content>
    }
    @else {
        <div class="d-flex justify-content-center">
            <mat-spinner diameter="20" class="mt-3" />
        </div>
    }
    
    <hr>
    <mat-dialog-actions>
        <button mat-raised-button class="enable-button" color="primary" (click)="save()">
            Save
        </button>
    </mat-dialog-actions>
</ng-template>
